"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.getHostnameFromUrl=function(e){-1===e.indexOf("https://")&&e.indexOf("http://")&&(e="https://"+e);try{return new URL(e).hostname.replace("www.","")}catch(e){return""}};
//# sourceMappingURL=url.js.map
